'use strict'
import { axios, getErrorMessage } from '../helpers/axioshelper'

export default {
  getTestMethod(testMethodId, languageId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/testmethods/${testMethodId}/language/${languageId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addTestMethod(testMethod) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/testmethods', testMethod)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateTestMethod(testMethod) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/testmethods/${testMethod.id}`, testMethod)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateTestMethodQuestionsOrder(testMethodId, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/testmethods/${testMethodId}/questions-order`, data)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteTestMethod(testMethod) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/testmethods/${testMethod.id}`)
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getAllTestMethods() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/testmethods')
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getActiveStandardTestMethods() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/testmethods?activeOnly=true')
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getQuestionFormats() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/testmethods/questionFormats')
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getTestMethodScales(testMethodId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/testmethods/${testMethodId}/scales`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getNormGroups(testMethodId, languageId) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/testmethods/${testMethodId}/normgroups?languageId=${languageId}`
        )
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getPdfTypes() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/testmethods/pdfTypes`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addNormGroup(testMethodId, normGroup) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/testmethods/${testMethodId}/normgroups`, normGroup)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateNormGroup(testMethodId, normGroup) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `/api/testmethods/${testMethodId}/normgroups/${normGroup.id}`,
          normGroup
        )
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteNormGroup(testMethodId, normGroupId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/testmethods/${testMethodId}/normgroups/${normGroupId}`)
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getNormScales(testMethodId, languageId, defaultLanguageId) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/testmethods/${testMethodId}/normscales?languageId=${languageId}&defaultLanguageId=${defaultLanguageId}`
        )
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateNormScales(
    testMethodId,
    normScaleIds,
    languageId,
    defaultLanguageId,
    doRandomize
  ) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `/api/testmethods/${testMethodId}/normscales?languageId=${languageId}&defaultLanguageId=${defaultLanguageId}&randomize=${doRandomize}`,
          normScaleIds
        )
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  }
}
